import React, { createContext, useContext } from 'react';
import LoadingBar from 'react-top-loading-bar';

export const LoadingBarContext = createContext<any>({});

let loadingBarRef: any;

const complete = () => loadingBarRef.complete();

const start = () => loadingBarRef.continuousStart();

const progress = () => {
  return loadingBarRef?.state.progress;
};

const LoadingBarProvider: React.FunctionComponent = ({ children }) => {
  return (
    <LoadingBarContext.Provider value={{ complete, start, progress }}>
      <LoadingBar
        height={3}
        className="react-loading-bar"
        color="#1285ff"
        onRef={(ref: any) => {
          loadingBarRef = ref;
        }}
      />
      {children}
    </LoadingBarContext.Provider>
  );
};

export default LoadingBarProvider;
